module.exports = __webpack_public_path__ + "img/left3.0803b230.png";